import { useShellContext } from '@omni/kit';
import { useEffect } from 'react';
import { Platform } from 'react-native';

import { ImageServiceType, parseImageUrl } from '../utilities/utilities';

export default function useFavicon(appId: string): void {
  const { app } = useShellContext();

  function getFaviconEl(elementId: string): HTMLLinkElement | null {
    return document.getElementById(elementId) as HTMLLinkElement;
  }

  useEffect(() => {
    const imageUrl = app?.branding?.mobileIcon;

    if (appId && Platform.OS === 'web' && imageUrl) {
      const icon = getFaviconEl('icon');
      const shortcutIcon = getFaviconEl('shortcut-icon');
      const appleTouchIcon = getFaviconEl('apple-touch-icon');

      if (icon) {
        icon.href = parseImageUrl(
          imageUrl,
          192,
          192,
          ImageServiceType.ImagePng
        ) as string;
      }

      if (shortcutIcon) {
        shortcutIcon.href = parseImageUrl(
          imageUrl,
          32,
          32,
          ImageServiceType.ImagePng
        ) as string;
      }

      if (appleTouchIcon) {
        appleTouchIcon.href = parseImageUrl(
          imageUrl,
          180,
          180,
          ImageServiceType.ImagePng
        ) as string;
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appId]);
}
